<!--
 * 
 * @author: Mengyu Jin
 * @since: 2022-10-14 14:14:15
-->

<template>
  <div class="page--alignment-editor-layout full flex-col">
    <HeaderPart :is-show-menu="false" :exitable="false" size="small">
      <template slot="title-append">
        <el-divider direction="vertical"></el-divider>
        <span style="font-weight: 100" :title="alignmentTaskName">{{
          alignmentTaskName
        }}</span>
      </template>
      <el-popover slot="menu-prefix" trigger="hover" title="双语对齐快捷键">
        <span
          slot="reference"
          class="clickable btn_close qa__popover-refrence--icon relative"
          style="line-height: 60px; color: #e6a23c; font-size: 18px; z-index: 1"
        >
          <svg-icon icon="ask" class="question-icon"></svg-icon>
        </span>
        <div
          class="operation-tip__content"
          style="line-height: 2"
          v-for="tip in OPERATION_TIPS"
          :key="tip.name"
        >
          <b>{{ tip.name }}： </b> {{ tip.content }}
        </div>
      </el-popover>
      <span
        class="clickable btn_close"
        slot="menu-append"
        style="
          line-height: 60px;
          color: #eaecee;
          font-size: 16px;
          margin-right: 20px;
        "
        @click="closeAndGotoParent"
        title="关闭"
      >
        <fa-icon icon="times"></fa-icon>
      </span>
    </HeaderPart>
    <EditorBody></EditorBody>
  </div>
</template>

<script>
import HeaderPart from "./components/Header";
import EditorBody from "@/views/alignment/editor";
import { mapGetters } from "vuex";
import { closeAndGotoParent } from "./components/data";
import { OPERATION_TIPS } from "@/views/alignment/components/data";
export default {
  components: {
    HeaderPart,
    EditorBody,
  },
  data() {
    return {
      OPERATION_TIPS: Object.freeze(OPERATION_TIPS),
    };
  },
  methods: {
    closeAndGotoParent,
  },
  computed: {
    ...mapGetters(["alignmentTaskName"]),
  },
};
</script>

<style lang="scss">
.page--alignment-editor-layout {
  background-color: #e5e5e5;
  overflow: hidden;
  min-width: 1200px;

  .innerContent {
    position: relative;
    overflow-y: hidden;
  }

  .page-container {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: 0.2s;
  }

  .btn_close:hover {
    opacity: 0.7;
  }

  .question-icon {
    border-radius: 100%;
    background: white;
    color: #e6a23c;
    vertical-align: text-top;
  }
}
</style>